import { render } from "./TurkeyMap.vue?vue&type=template&id=1c80ea70"
import script from "./TurkeyMap.vue?vue&type=script&lang=js"
export * from "./TurkeyMap.vue?vue&type=script&lang=js"

import "./TurkeyMap.vue?vue&type=style&index=0&id=1c80ea70&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__